import { useCallback } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { signOut } from 'aws-amplify/auth';

export const useCustomSignOut = () => {
    const { signOut: amplifySignOut } = useAuthenticator();

    const handleSignOut = useCallback(async () => {
        try {
            console.log('Custom Sign out');
            
            // Amplifyの標準サインアウト処理（クッキーも自動的に削除される）
            await signOut();
            amplifySignOut();
        } catch (error) {
            console.error('Error during sign out:', error);
            throw error;
        }
    }, [amplifySignOut]);

    return handleSignOut;
};